module.exports = __webpack_public_path__ + "images/category_lp/home_appliance/new/assessment_achievements/2_41afe0589946f5ec17444b48711ea28a.png";